export function toDateInputValue(date: string | null | undefined): string {
  if (!date) {
    return "";
  }

  return date.includes("T") ? date.split("T")[0] : date;
}

export function getPropertyReturnReferenceDate(
  purchaseDate: string | null,
  valuationSinceDate: string | null,
  registeredAt: string
): { label: string; date: string } {
  if (purchaseDate) {
    return { label: "Adquirido em", date: purchaseDate };
  }

  return {
    label: "Cadastrado em",
    date: valuationSinceDate ?? registeredAt,
  };
}

export function formatPropertyReturnDate(date: string): string {
  return new Intl.DateTimeFormat("pt-BR").format(new Date(`${toDateInputValue(date)}T12:00:00`));
}
